var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98 22V15.52H7.764C8.20133 15.52 8.58 15.568 8.9 15.664C9.22 15.76 9.468 15.9333 9.644 16.184C9.82533 16.4293 9.916 16.7787 9.916 17.232C9.916 17.4987 9.89467 17.736 9.852 17.944C9.80933 18.152 9.72933 18.3333 9.612 18.488C9.5 18.6373 9.33733 18.7627 9.124 18.864L10.012 22H8.532L7.82 19.096H7.412V22H5.98ZM7.412 18.272H7.812C8.01467 18.272 8.172 18.2373 8.284 18.168C8.396 18.0933 8.47333 17.9893 8.516 17.856C8.564 17.7173 8.588 17.552 8.588 17.36C8.588 17.0827 8.53733 16.8667 8.436 16.712C8.33467 16.5573 8.148 16.48 7.876 16.48H7.412V18.272ZM11.7784 22V16.584H10.8024V15.52H14.1864V16.584H13.2184V22H11.7784ZM15.2369 22V15.52H18.0369V16.488H16.6689V18.12H17.8609V19.12H16.6689V22H15.2369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.e026415c7d181bc9c056c9c4a9d30462.svg";
export { ForwardRef as ReactComponent };